<script lang="ts">
  import { scrollY } from '../../app-state.svelte';
  import { store } from '../store.svelte';
</script>

{#if scrollY() > 900 && !store.openId}
  <button
    class="totop"
    onclick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    aria-label="Наверх"
  >
    ↑
  </button>
{/if}

<style>
  .totop {
    position: fixed;
    bottom: 18px;
    left: 18px;
    z-index: 35;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(11, 10, 15, 0.75);
    backdrop-filter: blur(6px);
    border: 1px solid var(--hair);
    color: var(--ink-dim);
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;
    transition: color 0.25s, border-color 0.25s, opacity 0.4s;
    animation: rise 0.4s ease both;
  }
  .totop:hover {
    color: var(--ink);
    border-color: var(--mercury);
  }
  @keyframes rise {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .totop {
      animation: none;
    }
  }
</style>
